import { Language } from '../../utils/language';

type Localized = Record<Language, string>;

export interface OpenPosition {
  /** Offer id used by the register flow (?offer=) */
  id: string;
  title: Localized;
  sector: Localized;
  location?: Localized;
  /** Publication date of the LinkedIn post (YYYY-MM-DD) */
  publishedAt: string;
}

const same = (text: string): Localized => ({ es: text, en: text, ca: text, fr: text });

/**
 * Open positions published on the Conectio LinkedIn page
 * (https://www.linkedin.com/company/conectiodigital), newest first.
 * Only positions whose post links to the Conectio register (?offer=) are listed.
 * Update this list when positions are published or closed.
 */
export const OPEN_POSITIONS: OpenPosition[] = [
  {
    id: '167',
    title: {
      es: 'Ingeniero/a Técnico/a Industrial de Climatización e Instalaciones',
      en: 'Industrial Engineer – HVAC & Building Services',
      ca: 'Enginyer/a Tècnic/a Industrial de Climatització i Instal·lacions',
      fr: 'Ingénieur(e) industriel(le) – Génie climatique et installations',
    },
    sector: { es: 'Climatización, energía y obra pública', en: 'HVAC, energy & public works', ca: 'Climatització, energia i obra pública', fr: 'Génie climatique, énergie et travaux publics' },
    location: { es: 'Obra y oficina técnica', en: 'On-site & technical office', ca: 'Obra i oficina tècnica', fr: 'Chantier et bureau d’études' },
    publishedAt: '2026-10-14',
  },
  {
    id: '166',
    title: same('Test Engineer'),
    sector: { es: 'Packaging y maquinaria industrial', en: 'Packaging & industrial machinery', ca: 'Packaging i maquinària industrial', fr: 'Packaging et machines industrielles' },
    location: { es: 'Sant Cebrià de Vallalta · Viajes internacionales', en: 'Sant Cebrià de Vallalta · International travel', ca: 'Sant Cebrià de Vallalta · Viatges internacionals', fr: 'Sant Cebrià de Vallalta · Déplacements internationaux' },
    publishedAt: '2026-10-07',
  },
  {
    id: '131',
    title: same('Account Director'),
    sector: same('Life Sciences SaaS'),
    location: { es: '100% remoto · EE. UU. (Central Time)', en: '100% remote · US (Central Time)', ca: '100% remot · EUA (Central Time)', fr: '100 % télétravail · États-Unis (Central Time)' },
    publishedAt: '2026-10-05',
  },
  {
    id: '150',
    title: { es: 'Comercial de Forrajes', en: 'Forage Sales Representative', ca: 'Comercial de Farratges', fr: 'Commercial(e) Fourrages' },
    sector: { es: 'Agroalimentario', en: 'Agri-food', ca: 'Agroalimentari', fr: 'Agroalimentaire' },
    location: { es: 'España y Francia', en: 'Spain & France', ca: 'Espanya i França', fr: 'Espagne et France' },
    publishedAt: '2026-10-02',
  },
  {
    id: '160',
    title: same('Medical Content Project Manager'),
    sector: { es: 'Educación médica', en: 'Medical education', ca: 'Educació mèdica', fr: 'Formation médicale' },
    location: { es: 'Barcelona · Híbrido', en: 'Barcelona · Hybrid', ca: 'Barcelona · Híbrid', fr: 'Barcelone · Hybride' },
    publishedAt: '2026-09-30',
  },
  {
    id: '164',
    title: { es: 'Abogado/a Laboralista', en: 'Employment Lawyer', ca: 'Advocat/da Laboralista', fr: 'Avocat(e) en droit du travail' },
    sector: { es: 'Logística · Scale-up', en: 'Logistics · Scale-up', ca: 'Logística · Scale-up', fr: 'Logistique · Scale-up' },
    publishedAt: '2026-09-29',
  },
  {
    id: '144',
    title: same('Senior Backend Developer'),
    sector: same('MedTech / EdTech'),
    location: same('Barcelona'),
    publishedAt: '2026-09-28',
  },
  {
    id: '125',
    title: {
      es: 'Medical Sales Specialist / Delegado/a de Visita Médica',
      en: 'Medical Sales Specialist',
      ca: 'Medical Sales Specialist / Delegat/da de Visita Mèdica',
      fr: 'Medical Sales Specialist / Délégué(e) médical(e)',
    },
    sector: { es: 'Laboratorio farmacéutico', en: 'Pharmaceutical laboratory', ca: 'Laboratori farmacèutic', fr: 'Laboratoire pharmaceutique' },
    location: same('Barcelona'),
    publishedAt: '2026-09-22',
  },
  {
    id: '162',
    title: same('Business Development Manager (Data Centers)'),
    sector: { es: 'Automatización de edificios · Multinacional', en: 'Building automation · Multinational', ca: "Automatització d'edificis · Multinacional", fr: 'Automatisation des bâtiments · Multinationale' },
    publishedAt: '2026-09-15',
  },
  {
    id: '163',
    title: { es: 'Product Engineer (HVAC / Bombas de calor)', en: 'Product Engineer (HVAC / Heat pumps)', ca: 'Product Engineer (HVAC / Bombes de calor)', fr: 'Product Engineer (CVC / Pompes à chaleur)' },
    sector: { es: 'Automatización de edificios y eficiencia energética', en: 'Building automation & energy efficiency', ca: "Automatització d'edificis i eficiència energètica", fr: 'Automatisation des bâtiments et efficacité énergétique' },
    publishedAt: '2026-09-10',
  },
];
